<template>
  <form class="feedback" @submit.prevent="submit">
    <label for="email" class="label">My email</label>
    <input
      type="text"
      placeholder="Subject"
      id="email"
      :value="$store.state.coach.email"
      readonly
      required
    />
    <input type="text" placeholder="Subject" v-model="subject" required />
    <textarea placeholder="Body" v-model="body" rows="3"></textarea>
    <button type="submit" class="loadmore">
      <Loader v-if="loader" />
      <div class="submit-text" v-else>Submit</div>
    </button>
  </form>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader";

export default {
  components: {
    Loader
  },
  data() {
    return {
      subject: "",
      body: "",
      loader: false
    };
  },
  methods: {
    submit() {
      this.loader = true;

      const payload = {
        from: this.$store.state.coach.email,
        to: "playersdirectory@imlcacoaches.com",
        subject: this.subject,
        html: this.body
      };

      axios
        .post(
          "https://us-central1-prod-imlca.cloudfunctions.net/sendMailgunEmail",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "IMLCA"
            }
          }
        )
        .then(() => {
          this.loader = false;
          this.$modal.hideAll();
          this.$notify({
            group: "feedback",
            title: "Thank you",
            text: "Your feedback has been submitted"
          });
        })
        .catch(() => {
          this.loader = false;
          this.$modal.hideAll();
          this.$notify({
            group: "feedback-error",
            title: "Something went wrong",
            text: "Your feedback has not been submitted"
          });
        });
    }
  }
};
</script>


<style lang="scss">
.vm--modal {
  height: auto !important;
}

.feedback {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  padding: 50px;

  .label {
    align-self: flex-start;
    padding: 0;
    margin-bottom: 5px;
  }

  input {
    margin-bottom: 20px;
    padding: 5px;
  }

  textarea {
    padding: 5px;
    resize: none;
    margin-bottom: auto;
  }
}

.submit-text {
  height: 25px;
}
</style>